module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/2000-12-25/2000-12-25_dir-b4ffd9dd21359d3a90f6cdca83126fe3.gif";